import { getLatestImports } from '@sonar-software/sonar-imports';
import { LoadingSonar } from '@ui/icons/LoadingSonar';
import { OrganizationTypeId } from '@sonar-software/sonar-ts-types';

import { COPY_SPECIFIC, ImportStatus } from '@sonar-software/sonar-ts-constants';
import React, { useCallback, useState } from 'react';
import { useInterval, useOnMount } from '@hooks';

async function getLatestPardotImport() {
	const result = await getLatestImports({
		count: 1,
		organizationTypeId: OrganizationTypeId.Pardot
	});

	const latestImports = result.data ?? [];

	return latestImports.length ? latestImports[ 0 ] : undefined;
}

export const PardotSync: React.FC = () => {
	const [ inProgress, setInProgress ] = useState(false);

	const refresh = useCallback(async() => {
		const latestImport = await getLatestPardotImport();

		if (
			!latestImport ||
			latestImport.status === ImportStatus.Completed ||
			latestImport.status === ImportStatus.Failed
		) {
			setInProgress(false);

			return;
		}

		setInProgress(true);
	}, []);

	useOnMount(() => {
		refresh();
	});

	useInterval(() => {
		refresh();
	}, 5000);

	if (!inProgress) {
		return null;
	}

	return <LoadingSonar tooltip={ COPY_SPECIFIC.PARDOT_IS_SYNCING } />;
};
